var map = {
	"./ara": [
		604,
		27
	],
	"./ara.ts": [
		604,
		27
	],
	"./chi": [
		605,
		33
	],
	"./chi.ts": [
		605,
		33
	],
	"./dan": [
		606,
		42
	],
	"./dan.ts": [
		606,
		42
	],
	"./dut": [
		607,
		43
	],
	"./dut.ts": [
		607,
		43
	],
	"./eng": [
		383
	],
	"./eng.ts": [
		383
	],
	"./fin": [
		608,
		28
	],
	"./fin.ts": [
		608,
		28
	],
	"./fre": [
		609,
		29
	],
	"./fre.ts": [
		609,
		29
	],
	"./ger": [
		610,
		30
	],
	"./ger.ts": [
		610,
		30
	],
	"./gre": [
		611,
		31
	],
	"./gre.ts": [
		611,
		31
	],
	"./ita": [
		612,
		32
	],
	"./ita.ts": [
		612,
		32
	],
	"./jpn": [
		613,
		34
	],
	"./jpn.ts": [
		613,
		34
	],
	"./nor": [
		614,
		35
	],
	"./nor.ts": [
		614,
		35
	],
	"./por": [
		615,
		36
	],
	"./por.ts": [
		615,
		36
	],
	"./rum": [
		616,
		37
	],
	"./rum.ts": [
		616,
		37
	],
	"./rus": [
		617,
		38
	],
	"./rus.ts": [
		617,
		38
	],
	"./spa": [
		618,
		39
	],
	"./spa.ts": [
		618,
		39
	],
	"./swe": [
		619,
		40
	],
	"./swe.ts": [
		619,
		40
	],
	"./tha": [
		620,
		41
	],
	"./tha.ts": [
		620,
		41
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 827;
module.exports = webpackAsyncContext;